import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.previousFocus = document.activeElement
    this.focusableElements = Array.from(this.element.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.type !== "hidden" && element.getAttribute("aria-hidden") !== "true")
    this.focusableElements[0]?.focus()
  }

  disconnect() {
    if (this.previousFocus?.isConnected) {
      this.previousFocus.focus({ preventScroll: true })
    }
  }

  close() {
    this.element.remove()
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  trapFocus(event) {
    if (event.key !== "Tab" || this.focusableElements.length === 0) return

    const first = this.focusableElements[0]
    const last = this.focusableElements[this.focusableElements.length - 1]

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
